import React from 'react'
import { useOdometer } from '../../hooks/useOdometer'

/**
 * Displays a numeric target that counts up as the user scrolls.
 * @param {number} target   - final numeric value
 * @param {number} progress - scroll progress 0..1 from the containing section's --p var
 * @param {'kunit'|'infinity'|'plus'|'plain'} fmt
 */
export function MetricOdometer({ target, progress, fmt = 'plain', className = '' }) {
    const display = useOdometer(target, progress, fmt)
    return <span className={`metric-odometer ${className}`}>{display}</span>
}
